import vueDebounce from 'vue-debounce'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'

const app = createApp(App)

app.use(ElementPlus).directive('debounce', vueDebounce({ lock: true }))


app.mount('#app')
